// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";

import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrderForApproval";
import { DispatchDataCleanup } from "@rpsc/App/Handlers/OnePageCheckout/PlaceOrder";
import { CustomAppState } from "@rpsc/App/Store/Reducers";
import { getSettingsCollection } from "@rpsc/App/Store/Selectors/SettingsSelectors";

const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState();
    const { orderNotes, shipPartial, releaseNumber, deliveryAccount } = (state as CustomAppState).xCheckout;
    const carrierId = props.apiParameter.cart.carrier?.id;
    const settingCollectId = getSettingsCollection(state).xngShippingSettings?.collectCarrierId;
    props.apiParameter = {
        cart: {
            ...props.apiParameter.cart,
            notes: orderNotes || "",
            properties: {
                ...props.apiParameter.cart.properties,
                pscShipPartial: `${shipPartial}`,
                shippingAccountCarrier: settingCollectId === carrierId ? deliveryAccount.carrier : "", // reset them
                shippingAccountNumber: settingCollectId === carrierId ? deliveryAccount.number : "", // reset them
                releaseNumber,
            },
        },
    };
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToEndOfChain(chain, DispatchDataCleanup);
